import { actionGenerator } from '../../utils/redux/actionGenerator';
import { ELogoutActionTypes, TLogoutLoading } from './types';

export const logoutRequest: () => TLogoutLoading = actionGenerator<ELogoutActionTypes.Loading>(
  ELogoutActionTypes.Loading,
);
